import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { X } from "./icones";
import css from "./SuporteIA.module.css";
/** Print do chat: abre grande no centro da tela; clique na imagem alterna o zoom. Portal no body, pois a janela do chat corta overlays. */
export default function PrintAmpliado({ src, alt }) {
  const [aberto, setAberto] = useState(false);
  const [zoom, setZoom] = useState(false);
  const fechar = () => {
    setAberto(false);
    setZoom(false);
  };
  useEffect(() => {
    if (!aberto) return;
    // Captura + stop: o Esc fecha só a imagem, sem chegar ao Esc da janela do chat.
    const tecla = (e) => {
      if (e.key === "Escape") {
        e.stopPropagation();
        setAberto(false);
        setZoom(false);
      }
    };
    window.addEventListener("keydown", tecla, true);
    return () => window.removeEventListener("keydown", tecla, true);
  }, [aberto]);
  return (
    <>
      <button type="button" onClick={() => setAberto(true)} aria-label={`Ampliar ${alt}`} className={css.printBotao}>
        <img src={src} alt={alt} loading="lazy" className={css.printImagem} />
      </button>
      {aberto &&
        createPortal(
          <div role="dialog" aria-modal="true" aria-label={alt} onClick={fechar} className={css.printFundo}>
            <div className={css.printCaixa} onClick={(e) => e.stopPropagation()}>
              <img
                src={src}
                alt={alt}
                loading="eager"
                onClick={() => setZoom((z) => !z)}
                className={zoom ? css.printZoom : css.printInteiro}
                style={zoom ? { width: "min(200vw, 2400px)" } : undefined}
              />
            </div>
            <button type="button" onClick={fechar} aria-label="Fechar imagem" className={css.printFechar}>
              <X size={22} />
            </button>
          </div>,
          document.body,
        )}
    </>
  );
}
